import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Utilisateurs'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Les Clients'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Groupes de travail'
, [ TEXT.UI_MENU_JOBS          ]: 'Travail'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Clé MK'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Créer'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nouveau'
, [ TEXT.UI_BUTTON_OK          ]: "D'accord"
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Annuler'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Sauver'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Login'
, [ TEXT.UI_BUTTON_SEND        ]: 'Lancer'


, [ TEXT.UI_EMAIL              ]: 'Email'
, [ TEXT.UI_ROLE               ]: 'Rôle'
, [ TEXT.UI_USERNAME           ]: 'Utilisateur'
, [ TEXT.UI_NAME               ]: 'Nom'
, [ TEXT.UI_DATE               ]: 'Date'
, [ TEXT.UI_ADDR               ]: 'Adresse'
, [ TEXT.UI_DESC               ]: 'Description'
, [ TEXT.UI_PRICE              ]: 'Prix'
, [ TEXT.UI_NO_DATA            ]: 'Pas de données'
, [ TEXT.UI_MACHINES           ]: 'Machines'
, [ TEXT.UI_USERS              ]: 'Utilisateurs'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Connectez - Out'
, [ TEXT.UI_MKS_TYPE           ]: 'Type de MK système de clé'
, [ TEXT.UI_KEY_APP            ]: 'Utilisation de la clé'
, [ TEXT.UI_CLIENT             ]: 'Le Client'
, [ TEXT.UI_FILE               ]: 'Fichier'
, [ TEXT.UI_SELECT_FILE        ]: 'Choisir le fichier'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Utilisateur'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Cloud'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Mot de passe'



, [ TEXT.ARE_YOU_SURE          ]: 'Êtes-vous sûr?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Mauvais utilisateur / nuage ou mot de passe'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Mauvais utilisateur / nuage ou mot de passe'
, [ TEXT.ERROR_INTERNAL        ]: 'Erreur Interne du Serveur'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Accès refusé'
, [ TEXT.ERROR_UNKNOWN         ]: 'Il y avait une erreur, et cest tout ce que nous savons'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Page non trouvée'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Nouveau groupe de travail'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Modifier le groupe de travail'
, [ TEXT.WORKGROUPS_NAME       ]: 'Nom'
, [ TEXT.MACHINE_NAME          ]: 'Machine'


, [ TEXT.USERS_NEW_TITLE       ]: 'Nouvel utilisateur'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Modifier l utilisateur'


, [ TEXT.MACHINE_TYPE          ]: 'Type de machine'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Travail'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Nouveau client'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Modifier le client'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adresse'
, [ TEXT.CLIENT_CONTACT        ]: 'Contact'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Téléphone'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlp'
, [ TEXT.CLIENT_SURNAMES       ]: 'Prénom'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Anniversaire'
, [ TEXT.CLIENT_NOTES          ]: 'Remarques'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Nom du filtre'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Adresse du filtre'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrer le contact'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adresse'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Ville'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'State'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Code Postal'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Pays'


, [ TEXT.MACHINES_NEW          ]: 'Nouvelle machine'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Numéro de série'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Modifier le travail'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nouveau travail'
, [ TEXT.JOB_KEY_TYPE          ]: 'Type de clé'
, [ TEXT.JOB_NUM_KEYS          ]: 'Quantité'
, [ TEXT.JOB_MACHINE           ]: 'Machine'
, [ TEXT.JOB_STATUS            ]: 'Statut'
, [ TEXT.JOB_DATE              ]: 'Date'
, [ TEXT.JOB_QUANTITY          ]: 'Nouvelle quantité'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrer par statut'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrer les clients'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtre machine'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'type de clé de filtre'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrer par Date'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Lancer'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Lancer ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'télécharger le mastering'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} clés seront créées. Êtes-vous sûr?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} travail(s) ont été créés'
, [ TEXT.KEY_MASTERING_NAME               ]: 'nom du MK système de clé'


, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Mot de passe oublié?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Envoyé des instructions de repos à'
, [ TEXT.LOGIN_SLOGAN                   ]: 'La première application de duplication de clés basée sur le cloud'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Enregistrez les reproductions créées pour vos clients</li>
  <br>
  <li>Stockez vos données en toute sécurité et avec un accès de n'importe où  </li>
  <br>
  <li>Mise à jour automatique</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: "Mentions légales"
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Politique de confidentialité'
, [ TEXT.LEGAL_MODEL_TEXT            ]: "Modèle d'accord"
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/fr/legal_notice_fr.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/fr/privacy_policy_fr.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/fr/model_fr.docx'

, [ TEXT.KEY_MODEL                   ]: 'Clé'
, [ TEXT.KEY_SERIES                  ]: 'Séries'
, [ TEXT.KEY_CODE                    ]: 'Code'
, [ TEXT.KEY_DATA_SHEET              ]: 'Ficher'
, [ TEXT.KEY_BITING                  ]: 'Coupe'
, [ TEXT.KEY_APPLICATION             ]: 'Application'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'PENDANT'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ANULLÉ'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'ACHEVÉ'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'TRAITEMENT'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'VOITURE'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'MAISON'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SÉCURITÉ'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'CADENAS'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NON SPÉCIFIÉ'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Veuillez remplir les champs obligatoires en rouge'
}

export default ES ;
